export default "__VITE_ASSET__fRx7$JJu__"